const testMapping = [
  ["Standard Cylinder - 1 x 7 day, 2 x 28 day", "STANDARD_CYLINDER"],
  ["Early Age Cylinder - 1 day", "EARLY_AGE_CYLINDER_1_DAY"],
  ["Early Age Cylinder - 3 day", "EARLY_AGE_CYLINDER_3_DAY"],
  ["Early Age Cylinder - 4 day", "EARLY_AGE_CYLINDER_4_DAY"],
  ["Late Age Cylinder - 56 day", "LATE_AGE_CYLINDER_56_DAY"],
  ["Drying Shrinkage", "DRYING_SHRINKAGE"],
  ["Air", "AIR"],
  ["Flexural Strength - 1 x 7 day, 2 x 28 day", "FLEXURAL_STRENGTH"],
  ["Other", "OTHER"],
];
const frequencyMapping = [
  ["1/50M3", "1_50M3"],
  ["1/100M3", "1_100M3"],
  ["1/25M3", "1_25M3"],
  ["QLD MRTS70 Testing Frequency", "QLD_MRTS70"],
  ["NSW RMS B80 Testing Frequency", "NSW_RMS_B80"],
  ["NSW RMS R82 Testing Frequency", "NSW_RMS_R82"],
  ["NSW RMS R83 Testing Frequency", "NSW_RMS_R83"],
  ["Test Every Load", "TEST_EVERY_LOAD"],
];

interface TestDetails {
  testRequirements: string;
  testFrequency?: string;
  selectedNotes: string;
}

export function getTestDetailsFromInstructions(driverInstructions: string): TestDetails {
  const testDetails: TestDetails = {
    testRequirements: "NO_TESTING_REQUIRED",
    selectedNotes: "",
  };
  const testingDescription = driverInstructions.match(/Test Requested: (.*)/);
  if (testingDescription && testingDescription.length) {
    let testNotes = testingDescription[1];
    for (let i = 0; i < testMapping.length; i++) {
      const [pattern, testRequirements] = testMapping[i];
      if (new RegExp(pattern).test(testNotes)) {
        testDetails.testRequirements = testRequirements;
        testNotes = testNotes.replace(pattern, "");
        break;
      }
    }
    for (let i = 0; i < frequencyMapping.length; i++) {
      const [pattern, testFrequency] = frequencyMapping[i];
      if (new RegExp(pattern).test(testNotes)) {
        testDetails.testFrequency = testFrequency;
        testNotes = testNotes.replace(pattern, "");
        break;
      }
    }
    // remove site contact details when instruction ordering is different
    testDetails.selectedNotes = testNotes.replace(/Site Contact: \w+(?: \w+)* \d{10}/, "").trim();
  }
  return testDetails;
}
